<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>
      </el-col>
    </el-row>

    <el-form
      :model="saleInfo"
      status-icon
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="课程名称">
        <el-col :span="15">
          <el-input
            v-model="saleInfo.title"
            placeholder="请选择课程"
            :disabled="true"
          ></el-input>
        </el-col>
        <el-button
          v-if="create"
          type="primary"
          size="small"
          @click="
            search.chooseOrgVisible = true;
            searchData();
          "
        >
          查询
        </el-button>
      </el-form-item>

      <el-form-item label="课程原价">
        <div>{{ saleInfo.price }}</div>
      </el-form-item>

      <el-form-item label="秒杀价格">
        <el-col :span="5">
        <el-input
          v-model="saleInfo.flash_sale_price"
          placeholder="请输入秒杀价格"
          @input="change($event)"
        >
        <span slot="suffix">元</span>
        </el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="限购人数">
        <div>{{ saleInfo.limit_user_num }}&nbsp;份</div>
      </el-form-item>

      <el-form-item label="秒杀数量" >
        <el-col class="add_flex">
          <el-col :span="5">
        <el-input
          type="text"
          v-model="saleInfo.stock"
          placeholder="请输入秒杀数量"
        ></el-input>
        </el-col>
        <div class="tips_msg">（秒杀数量最小不得小于1，最大不得大于10 0000）</div>
        </el-col>
      </el-form-item>
      <el-form-item label="虚拟数量">
        <el-col class="add_flex">
          <el-col :span="5">
        <el-input
          v-model="saleInfo.flash_sale_number_v"
          placeholder="请输入虚拟数量"
        ></el-input>
        </el-col>
        <div class="tips_msg">（前端显示的虚拟已抢数量，虚拟数量不得小于1，最大不超过10 0000）</div>
        </el-col>
      </el-form-item>

      <el-form-item label="秒杀时间">
        <el-date-picker
          v-model="saleInfo.begin_at"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择开始时间"
        >
        </el-date-picker>
        ~
        <el-date-picker
          v-model="saleInfo.end_at"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          default-time="23:59:59"
          placeholder="选择结束时间"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item v-if="1 == 0" label="叠加优惠">
        <el-checkbox-group
          v-model="is_discount"
          @change="checkBoxChange($event, 'is_discount')"
        >
          <el-checkbox
            label="不可叠加（所有优惠券、会员折扣、代理商折扣券均不可用）"
          ></el-checkbox>
        </el-checkbox-group>
        <el-checkbox-group
          v-model="discount_vip"
          @change="checkBoxChange($event, 'discount_vip')"
        >
          <el-checkbox label="可与会员折扣叠加使用"></el-checkbox>
        </el-checkbox-group>
        <el-checkbox-group
          v-model="discount_coupon"
          @change="checkBoxChange($event, 'discount_coupon')"
        >
          <el-checkbox label="可与优惠券叠加使用"></el-checkbox>
        </el-checkbox-group>
        <el-checkbox-group
          v-model="discount_agent"
          @change="checkBoxChange($event, 'discount_agent')"
        >
          <el-checkbox label="可与代理折扣券叠加使用"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item>
        <el-button
          size="small"
          type="primary"
          @click="create == true ? createInfo() : updateInfo()"
          :loading="updateLoading"
          >确 定</el-button
        >
      </el-form-item>
    </el-form>

    <el-dialog
      title="选择商品"
      :visible.sync="search.chooseOrgVisible"
      :close-on-click-modal="true"
      :before-close="addEditFormOnClose"
      width="75%"
    >
      <el-form :inline="true" :model="search.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
            size="small"
            v-model="search.query.search"
            placeholder="请输入标题"
            clearable
            @blur="searchData()"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="
              searchData();
            "
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>

      <el-tabs v-model="search.activeName" @tab-click="handleClick">
        <el-tab-pane label="普通课程" name="1"></el-tab-pane>
        <el-tab-pane label="直播课" name="3"></el-tab-pane>
        <el-tab-pane label="线下课" name="5"></el-tab-pane>
        <el-tab-pane label="专题课" name="12"></el-tab-pane>
        <el-tab-pane label="有声书" name="6"></el-tab-pane>
      </el-tabs>

      <!--列表-->
      <el-table
        border
        :data="search.result.data"
        highlight-current-row
        v-loading="search.listLoading1"
        style="..."
      >
        <el-table-column label="ID" align="center">
          <template slot-scope="{ row }">
            {{ row.id }}{{ row.extra_type == 1 ? ('【排期课】') : '' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="标题"
          align="center"
        ></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px" alt="" />
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="selectProduct(row)">
              确定
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="searchData"
        :current-page.sync="search.query.page"
        :page-size="search.query.limit"
        layout="total, prev, pager, next, jumper"
        :total="search.result.total"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import {
  screenProductList,
} from "@/api/coupon";

import {
  createFlashSaleCourse,
  flashSaleInfoShow,
  flashSaleInfoUpdate,
} from "@/api/promotion";

export default {
  data: function () {
    return {
      create: true,
      updateLoading: false,
      is_discount: true,
      discount_vip: false,
      discount_coupon: false,
      discount_agent: false,
      saleInfo: {
        id: 0,
        target_id: 0,
        type: 2, //2-课程，3-课程包，1-商品，4-排期课
        title: "",
        price: 0,
        limit_user_num: 0,
        flash_sale_price: 0,
        begin_at: "",
        end_at: "",
        stock: 0,
        flash_sale_number_v: 0,
        is_discount: 0,
        discount_vip: 0,
        discount_coupon: 0,
        discount_agent: 0
      },
      search: {
        chooseOrgVisible: false,
        listLoading1: false,
        activeName: "1",
        query: {
          type: 1,
          search: "",
          page: 1,
          limit: 5,
          target_type: 1,
          extra_type: 2,// 限定非排期课，0-不限（即全部），1-限定搜排期课，2-限定搜非排期课
        },
        result: {
          total: 0,
          data: [],
        },
      },
    };
  },
  mounted: function () {
    this.saleInfo.id = this.$route.query.id;
    if (this.saleInfo.id > 0) {
      this.create = false;
      this.getInfo();
    }
  },
  methods: {
    getInfo() {
      this.loading = true;
      flashSaleInfoShow({
        id: this.saleInfo.id,
      }).then((response) => {
        if (response.status == 2000) {
          this.saleInfo = response.data;
          if (this.saleInfo.is_discount == 0) {
            this.is_discount = true;
          } else {
            this.is_discount = false;
          }
          if (this.saleInfo.discount_vip == 1) {
            this.discount_vip = true;
          } else {
            this.discount_vip = false;
          }
          if (this.saleInfo.discount_coupon == 1) {
            this.discount_coupon = true;
          } else {
            this.discount_coupon = false;
          }
          if (this.saleInfo.discount_agent == 1) {
            this.discount_agent = true;
          } else {
            this.discount_agent = false;
          }
        }
        this.loading = false;
      });
    },
    updateInfo() {
      this.updateLoading = true;
      flashSaleInfoUpdate(this.saleInfo)
        .then((response) => {
          this.updateLoading = false;
          if (response.status == 2000) {
            this.$message.success(response.message);
            this.$router.push({
              path: "/promotion/flashSaleList",
            });
          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },
    change(e) {
      this.$forceUpdate();
    },
    handleClick(tab, event) {
      this.search.query.target_type = Number(tab.name);
      this.search.query.page = 1;
      this.searchData();
      if (this.search.query.target_type == 12) {
        this.saleInfo.type = 3;
      } else {
        this.saleInfo.type = 2;
      }
    },
    // 弹窗关闭
    addEditFormOnClose() {
      this.search.query.page = 1;
      this.search.activeName = "1";
      this.search.query.type = 1;
      this.search.query.search = "";
      this.search.query.target_type = 1;

      this.search.result = {
        total: 0,
        data: [],
      };
      this.search.chooseOrgVisible = false;
      
    },
    // 查询方法
    searchData() {
      this.search.listLoading1 = true;
      screenProductList(this.search.query).then((response) => {
        this.search.result.data = response.data.list;
        this.search.result.total = response.data.total;
        this.search.listLoading1 = false;
      });
    },
    selectProduct(row) {
      if (this.saleInfo.type == 2 && row.extra_type != undefined && row.extra_type == 1) {
        this.$message({
            showClose: false,
            message: '请再秒杀列表点击“新建排期课程秒杀” 创建排期课的秒杀活动',
            type: "error",
          });
          return;
      }

      this.saleInfo.limit_user_num = row.limit_user_num;
      this.saleInfo.target_id = row.id;
      this.saleInfo.title = row.title;
      this.saleInfo.price = row.price;
      this.saleInfo.flash_sale_price = row.price;

      this.search.chooseOrgVisible = false;
    },
    createInfo() {
      console.log(this.saleInfo);
      this.updateLoading = true;
      createFlashSaleCourse(this.saleInfo)
        .then((response) => {
          this.updateLoading = false;
          if (response.status == 2000) {
            this.$message.success(response.message);
            this.$router.push({
              path: "/promotion/flashSaleList",
            });
          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },
    checkBoxChange(event, discountType) {
      if (event) {
        if (discountType == "is_discount") {
          this.saleInfo.is_discount = 0;
          this.discount_vip = this.discount_coupon = this.discount_agent = false;
          this.saleInfo.discount_vip = this.saleInfo.discount_coupon = this.saleInfo.discount_agent = 0;
        }
        if (discountType == "discount_vip") {
          this.saleInfo.discount_vip = 1;
          this.saleInfo.is_discount = 1;
          this.is_discount = false;
        }
        if (discountType == "discount_coupon") {
          this.saleInfo.discount_coupon = 1;
          this.saleInfo.is_discount = 1;
          this.is_discount = false;
        }
        if (discountType == "discount_agent") {
          this.saleInfo.discount_agent = 1;
          this.saleInfo.is_discount = 1;
          this.is_discount = false;
        }
      } else {
        if (discountType == "is_discount") {
          this.saleInfo.is_discount = 1;
        }
        if (discountType == "discount_vip") {
          this.saleInfo.discount_vip = 0;
          this.saleInfo.is_discount = 1;
          this.is_discount = false;
        }
        if (discountType == "discount_coupon") {
          this.saleInfo.discount_coupon = 0;
          this.saleInfo.is_discount = 1;
          this.is_discount = false;
        }
        if (discountType == "discount_agent") {
          this.saleInfo.discount_agent = 0;
          this.saleInfo.is_discount = 1;
          this.is_discount = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.add_flex{
  display: flex;
}
.tips_msg{
  margin-left: 20px;
  flex-shrink: 0;
}
</style>